<template>
  <header-menu
    v-if="isUserLoggedIn"
    class="user-menu"
    id="user-menu"
    :modifiers="['right']">
    <ul
      class="user-menu__list">
      <li
        v-if="isUserLoggedIn && isUserBasic"
        class="user-menu__item user-menu__item--upgrade">
        <header-link
          id="upgrade"
          v-if="hasUpgradeLink"
          class="user-menu__button"
          :only-login="true"
          :only-basic="true" />
      </li>
      <li class="user-menu__item user-menu__item--discover">
        <header-link
          id="discover"
          class="user-menu__link" />
      </li>
      <li class="user-menu__item user-menu__item--library">
        <header-link
          id="library"
          class="user-menu__link" />
      </li>
      <li class="user-menu__item user-menu__item--highlights">
        <header-link
          id="highlights"
          class="user-menu__link" />
      </li>
      <li class="user-menu__item user-menu__item--invite">
        <header-link
          class="user-menu__link"
          id="invite" />
      </li>
      <li class="user-menu__item user-menu__item--wishlist">
        <header-link
          class="user-menu__link"
          id="wishlist" />
      </li>
      <li class="user-menu__item user-menu__item--settings">
        <header-link
          class="user-menu__link"
          id="settings" />
      </li>
      <li class="user-menu__item user-menu__item--help">
        <header-link
          class="user-menu__link"
          id="help" />
      </li>
      <li class="user-menu__item user-menu__item--logout">
        <header-link
          class="user-menu__link"
          id="logout" />
      </li>
    </ul>
  </header-menu>
</template>

<script>
import { mapGetters } from "vuex";
import HeaderLink from "./header-link";
import HeaderMenu from "./header-menu";

export default {
  name: "UserMenu",
  components: {
    HeaderLink,
    HeaderMenu
  },
  props: {
    hasUpgradeLink: { type: Boolean, default: true }
  },
  computed: {
    ...mapGetters(["isUserLoggedIn", "isUserBasic"])
  }
};
</script>

<style lang="scss">
.user-menu {
  $root: &;

  &__list {
    box-sizing: border-box;
    height: 100%;
    padding: $spacing-8 $spacing-16;

    background-color: $white;

    @include media(max-width, m) {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 2001; // More that smartbanner

      width: 100vw;
      height: auto;
      overflow: auto;
    }

    @include media(min-width, m) {
      height: auto;

      border-bottom-right-radius: $border-radius-4;
      border-bottom-left-radius: $border-radius-4;
    }
  }

  &__item {
    display: flex;
    justify-content: center;

    &:not(:last-child) {
      border-bottom: $lightest-grey solid 1px;
    }
  }

  &__link {
    @include font-style(button, $color: $midnight);

    display: block;
    width: 100%;
    padding: $spacing-16;

    cursor: pointer;

    &:hover {
      color: $green;
    }
  }

  &__button {
    width: 100%;
    max-width: $x-wide-block-width;
    margin: $spacing-16 0;
  }

  @include media(min-width, m) {
    position: relative;

    #{$root}__item {

      /* stylelint-disable-next-line selector-nested-pattern */
      &--discover,
      &--library,
      &--upgrade {
        display: none;
      }
    }
  }

  @include media(min-width, l) {

    #{$root}__item {

      &--highlights {
        display: none;
      }
    }
  }
}
</style>
